import { Component, computed, input, InputSignal, output, OutputEmitterRef, Signal } from "@angular/core";
import { CsIconModule } from "@components/icon";
import { SwiperModule } from "swiper/angular";
import { ProductCollection } from "@cureskin/api-client/src/server-api";

@Component({
  selector: "app-product-collection-banner",
  imports: [CsIconModule, SwiperModule],
  templateUrl: "./product-collection-banner.component.html",
  standalone: true
})
export class ProductCollectionBannerComponent {
  collection: InputSignal<ProductCollection> = input<ProductCollection>();
  viewCollection: OutputEmitterRef<string> = output<string>();

  title: Signal<string> = computed(() => this.collection()?.title);
  name: Signal<string> = computed(() => this.collection()?.name);
}
